<template>
    <div>
        <measurement-filter @filtered = " (val) => extraFilters = {...extraFilters, ...val }"></measurement-filter>

        <elements-layout
              :table-columns='tableColumns'
              :fetch-data-url='fetchDataUrl'
              :extra-filters="extraFilters"

              :tableRepresentation="true"

              :store-module-name="STORE_MODULE_NAME"
              :store-module-config="STORE_MODULE_CONFIG"

              :extra-views="[{ icon: 'MapIcon', value: 'map-view', available: true }]"
        >
            <template #tableCellCustomRepresentations="cell">
            <template v-if="cell.field.key === 'object'">
              <template v-if="get(cell.value, 'id')">
                  <b-media vertical-align="center">
                      <template #aside>
                            <b-avatar
                              size="32"
                              :src="cell.avatar"
                              :text="avatarText(cell.value.number)"
                              variant="light-primary"
                              :to="{ name: 'measurements-measurement-view', params: { id: cell.item.id } }"
                            />
                        </template>

                      <b-link :to="{ name: 'measurements-measurement-view', params: { id: cell.item.id } }"
                              class="font-weight-bold d-block text-nowrap"
                      >
                        {{cell.value.object_type.type}}
                      </b-link>
                      <small class="text-muted">{{cell.value.number }}</small>
                  </b-media>
              </template>
              <template v-else>
                {{cell.value}}
              </template>
          </template>
          <template v-else-if="cell.field.key === 'user'">
              <template v-if="get(cell.value, 'id')">
                  <user-cell :user="cell.value"></user-cell>
              </template>
              <template v-else>
                {{cell.value}}
              </template>
          </template>
          <!-- Норма у вида замера может быть не задана (admittance = null).
               Прежде разметка обращалась к admittance.upper без проверки: на
               первой же такой записи отрисовка падала, и таблица навсегда
               оставалась в «Загрузка данных …» — при том что счётчик внизу
               честно показывал число записей. -->
          <template v-else-if="cell.field.key === 'value'">
              <b-badge pill
                       :variant="measurementValueVariant(cell.item)"
                       class="text-capitalize"
                       v-b-tooltip.hover.top="measurementValueHint(cell.item)"
              >
                {{ cell.value }}
              </b-badge>
          </template>
        </template>

            <template #extraRepresentations="{ itemView, fetchedData }">
                <template v-if="itemView === 'map-view'">
                    <measurement-list-map-representation :data="fetchedData" :filters="extraFilters"></measurement-list-map-representation>
                </template>
            </template>
        </elements-layout>
    </div>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../measurementStoreModule'
  import useMeasurement from '../useMeasurement'

  import get from 'lodash.get'
  import UserCell from "@/views/apps/user/components/UserCell";

  import {BMedia, BBadge, BLink, BAvatar, VBTooltip} from 'bootstrap-vue'
      import { avatarText } from '@core/utils/filter'
  import MeasurementFilter from "../components/MeasurementFilter";
  import MeasurementListMapRepresentation from "../components/MeasurementListMapRepresentation";


  export default {
    components: {
        MeasurementListMapRepresentation,
        MeasurementFilter,
        UserCell,
        ElementsLayout,

        BMedia, BBadge, BLink, BAvatar
    },
      directives: {
        'b-tooltip': VBTooltip,
      },
    setup() {

      const {
          fetchDataUrl,
          tableColumns,
          extraFilters,
          resolveMeasurementValue,

      } = useMeasurement();

      return {
          fetchDataUrl,
          tableColumns,
          extraFilters,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,

          resolveMeasurementValue,
          avatarText
      }
    },
    methods: {
      /** Норма для вида замера этой записи; null, если норма не задана. */
      admittanceFor(item) {
        const types = get(item, 'object.object_type.measurement_type_for_object_type', []) || []
        const found = types.find(
          (t) => get(t, 'measurement_type.id') === get(item, 'type.id'),
        )
        return get(found, 'admittance', null)
      },
      measurementValueVariant(item) {
        const admittance = this.admittanceFor(item)
        if (!admittance) return 'light-secondary'
        return `light-${this.resolveMeasurementValue(item.value, admittance.upper, admittance.lower)}`
      },
      measurementValueHint(item) {
        const admittance = this.admittanceFor(item)
        if (!admittance) return 'Норма для этого вида замера не задана'
        return `Диапазон от ${admittance.lower} до ${admittance.upper}`
      },
    },
  }
</script>
